import React, { useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { COWORKING } from '@/types/spaceTypes.constants';
import { format } from 'date-fns';
import { calculateHoursDifference } from '@/helpers/dateHelpers';
import { saveCheckout } from '@/services/reservationService';
import { loadStripe } from '@stripe/stripe-js';

export const usePaymentForm = (spaceDetail, formValues) => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoadingCheckout, setIsLoadingCheckout] = useState(false);

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  const getSripeOptions = (amount) => {
    return {
      mode: 'payment',
      amount: Math.round(amount * 100),
      currency: 'mxn',
      //currency: 'mxn',
      appearance: {
        /*...*/
      },
    };
  };

  /*
  const getTotalPrice = () => {
    const pricePerTime =
      formValues?.spaceType === COWORKING ? spaceDetail?.rate_24_hours : spaceDetail?.hourly_rate;
    const hours = calculateHoursDifference(formValues?.startTime, formValues?.endTime);
    if (formValues?.spaceType === COWORKING) {
      return pricePerTime * (formValues?.guestQuantyty || 1);
    } else {
      return pricePerTime * (hours > 0 ? hours : 0);
    }
  };
  */

  const getTotalPrice = () => {
    let total;
    const price = parseFloat(spaceDetail?.calculatedPrice || '0');
    const hours = calculateHoursDifference(formValues?.startTime, formValues?.endTime);
    if (formValues?.spaceType === COWORKING) {
      total = price * (formValues?.guestQuantyty || 1);
    } else {
      total = price * (hours > 0 ? hours : 0);
    }
    return total;
  };

  const submitPaymentForm = async (event, stripe, elements) => {
    setIsLoadingCheckout(true);
    event.preventDefault();
    if (elements == null) {
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      return;
    }

    const parsedTotalPrice = parseFloat(getTotalPrice());
    const amount = Math.round(parsedTotalPrice * 100);
    const currency = spaceDetail?.currency?.toLowerCase();

    const reservation = {
      host_id: 1,
      guest_id: 2,
      space_subtype_relationship: spaceDetail?.id_relationship,
      start_date: formValues?.startDate,
      finish_date: formValues?.startDate,
      initial_price: parsedTotalPrice,
      final_price: parsedTotalPrice,
      id_state: 1,
      payment_method: 1,
      method_status: 'p',
      method_details: 'Credit Card',
    };

    const { client_secret, createdReservation } = await saveCheckout({
      amount,
      currency,
      reservation: reservation,
    });

    ReactPixel.trackCustom('StripePaymentButton', {
      clave: true,
    });

    const { error } = await stripe.confirmPayment({
      elements,
      clientSecret: client_secret,
      confirmParams: {
        /*
        return_url:
          'http://localhost:3000/reserva-confirmada?transaction_id=' +
          createdReservation?.transaction_id,
      */
        return_url:
          'https://popnest.org/reserva-confirmada?transaction_id=' +
          createdReservation?.transaction_id,
      },
    });

    if (error) {
      ReactPixel.trackCustom('StripePaymentError', {
        errorMessage: error.message,
      });
      setErrorMessage(error.message);
      setIsLoadingCheckout(false);
    } else {
      console.log('Pago exitoso');
      setIsLoadingCheckout(false);
    }
  };

  useEffect(() => {
    if (spaceDetail && formValues && stripePromise) {
      setIsLoading(false);
    }
  }, [spaceDetail, formValues, stripePromise]);

  return {
    isLoading,
    setIsLoading,
    stripePromise,
    getSripeOptions,
    getTotalPrice,
    errorMessage,
    isLoadingCheckout,
    submitPaymentForm,
  };
};
